import * as React from 'react';
import styled from '@emotion/styled';
import { Route, Routes } from 'react-router-dom';
import Search from './Main/Search';
import UploadFile from './Main/UploadFile';
import PersonOutline from './Main/PersonOutline';
import LoginPage from './Main/LoginPage';
import Layout from './Main/Layout';
import LoginUnauthorized from './Main/Unauthorized';
import NotFound from './Main/NotFound';
import { RequireAuth } from '../utils/authentication/use-Auth';
import ROLE from '../utils/authentication/roles';
import LoginOut from './Main/LoginOut';

const StyledSection = styled.div`
  padding: 0 0;
`;

const StyledContainer = styled.div`
  max-width: 1920px;
  padding: 15px;
  margin: auto;
  min-height: 100vh;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
`;

const App = () => {
  return (
    <StyledSection>
      <StyledContainer>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="unauthorized" element={<LoginUnauthorized />} />
          <Route path="dashboard" element={<Layout />}>
            <Route index element={<Search />} />
            <Route path="person" element={<PersonOutline />} />
            <Route path="search" element={<Search />} />
            <Route path="logout" element={<LoginOut />} />
            <Route
              path="uploadFile"
              element={
                <RequireAuth roles={[ROLE.admin]}>
                  <UploadFile />
                </RequireAuth>
              }
            />
          </Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </StyledContainer>
    </StyledSection>
  );
};

export default App;
